/* alvero — small, dependency-free behaviours. Everything degrades to plain HTML. */
(function () {
  'use strict';

  function each(selector, fn, root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(selector), fn);
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function el(tag, text, cls) {
    var node = document.createElement(tag);
    node.textContent = text;
    if (cls) node.className = cls;
    return node;
  }

  var ticks = [];

  function init(root) {
    /* Mobile menu */
    each('[data-av-menu-btn]', function (btn) {
      if (btn.dataset.avReady) return;
      btn.dataset.avReady = '1';
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      btn.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }, root);

    /* Countdown to the real end of the offer (date set in Theme settings > Offer).
       When the time is up the countdown removes itself. It never restarts. */
    each('[data-av-countdown]', function (box) {
      if (box.dataset.avReady) return;
      box.dataset.avReady = '1';
      var end = parseInt(box.getAttribute('data-end'), 10) * 1000;
      var clock = box.querySelector('[data-av-countdown-clock]');
      var fallback = box.querySelector('[data-av-countdown-static]');
      if (!end || !clock) return;
      var d = clock.querySelector('[data-d]'), h = clock.querySelector('[data-h]');
      var m = clock.querySelector('[data-m]'), s = clock.querySelector('[data-s]');
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { box.hidden = true; return false; }
        if (d) d.textContent = pad(Math.floor(left / 86400));
        if (h) h.textContent = pad(Math.floor((left % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
        if (s) s.textContent = pad(left % 60);
        return true;
      }
      if (tick()) {
        var label = box.querySelector('[data-av-countdown-label]');
        clock.hidden = false;
        if (label && label.getAttribute('data-live')) {
          if (fallback) fallback.textContent = label.textContent + ' ' + fallback.textContent;
          label.textContent = label.getAttribute('data-live');
          label.setAttribute('aria-hidden', 'true');
        }
        if (fallback) fallback.classList.add('av-vh');
        ticks.push(tick);
      }
    }, root);

    /* Quantity steppers (cart page) */
    each('[data-av-qty]', function (box) {
      if (box.dataset.avReady) return;
      box.dataset.avReady = '1';
      var input = box.querySelector('input');
      if (!input) return;
      each('button[data-step]', function (btn) {
        btn.addEventListener('click', function () {
          var min = input.min === '' ? 0 : parseInt(input.min, 10);
          var value = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10);
          input.value = Math.max(min, value);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }, box);
      if (box.hasAttribute('data-av-autosubmit')) {
        input.addEventListener('change', function () { if (input.form) input.form.submit(); });
      }
    }, root);

    /* Product form: option cards drive the real <select name="id">,
       then price, stock line, buy button and sticky bar follow the selection. */
    each('[data-av-product-form]', function (form) {
      if (form.dataset.avReady) return;
      form.dataset.avReady = '1';
      var select = form.querySelector('select[name="id"]');
      if (!select) return;
      var scope = form.closest('[data-av-product]') || document;
      var priceBox = scope.querySelector('[data-av-price]');
      var stock = scope.querySelector('[data-av-stock]');
      var addBtn = form.querySelector('[data-av-add]');
      var cards = form.querySelector('[data-av-variants]');
      var selectWrap = form.querySelector('[data-av-variant-select]');

      function sync() {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var data = option.dataset;
        var available = data.available === 'true';

        if (priceBox && data.price) {
          priceBox.textContent = '';
          priceBox.appendChild(el('span', data.price));
          if (data.compare) {
            priceBox.appendChild(el('s', data.compare));
            priceBox.appendChild(el('span', 'Save ' + data.save, 'av-price__save'));
          }
        }
        each('[data-av-sticky-price]', function (node) {
          node.textContent = data.price || '';
          if (data.compare) node.appendChild(el('s', data.compare));
        });
        if (addBtn) {
          var label = addBtn.querySelector('[data-av-add-label]');
          var btnPrice = addBtn.querySelector('[data-av-btn-price]');
          addBtn.disabled = !available;
          if (label) label.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
          if (btnPrice) { btnPrice.textContent = data.price || ''; btnPrice.hidden = !available; }
        }
        if (stock) {
          var text = stock.querySelector('[data-av-stock-text]');
          var threshold = parseInt(stock.getAttribute('data-threshold'), 10) || 0;
          var count = data.stock === '' || data.stock === undefined ? null : parseInt(data.stock, 10);
          stock.classList.remove('is-low', 'is-out');
          if (!available) { stock.classList.add('is-out'); text.textContent = 'Sold out'; }
          else if (count !== null && count > 0 && count <= threshold) { stock.classList.add('is-low'); text.textContent = 'Only ' + count + ' left in stock'; }
          else { text.textContent = 'In stock'; }
        }
      }

      if (cards) {
        cards.hidden = false;
        if (selectWrap) selectWrap.hidden = true;
        each('input[type="radio"]', function (radio) {
          radio.addEventListener('change', function () {
            if (!radio.checked) return;
            select.value = radio.value;
            sync();
          });
        }, cards);
      }
      select.addEventListener('change', sync);
    }, root);

    /* Product gallery thumbnails */
    each('[data-av-gallery]', function (gallery) {
      if (gallery.dataset.avReady) return;
      gallery.dataset.avReady = '1';
      var track = gallery.querySelector('[data-av-track]');
      var thumbs = gallery.querySelectorAll('[data-av-thumb]');
      if (!track || !thumbs.length) return;
      function mark(index) {
        Array.prototype.forEach.call(thumbs, function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      }
      Array.prototype.forEach.call(thumbs, function (thumb, index) {
        thumb.addEventListener('click', function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: track.clientWidth * index, behavior: reduce ? 'auto' : 'smooth' });
          mark(index);
        });
      });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))); }, 80);
      });
    }, root);

    /* Sticky buy bar */
    each('[data-av-sticky]', function (bar) {
      if (bar.dataset.avReady) return;
      bar.dataset.avReady = '1';
      var mainBtn = document.querySelector('[data-av-add]');
      if (mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          /* Show the bar whenever the main buy button is off screen, above or below,
             so on a phone the buy button is reachable from the first second. */
          var show = !entries[0].isIntersecting;
          bar.hidden = !show;
          document.body.classList.toggle('av-has-sticky', show);
        }).observe(mainBtn);
      } else if (!mainBtn) {
        bar.hidden = false;
        document.body.classList.add('av-has-sticky');
      }
      each('[data-av-sticky-buy]', function (link) {
        link.addEventListener('click', function (event) {
          var form = document.querySelector('[data-av-product-form]');
          if (!form) return;
          var btn = form.querySelector('[data-av-add]');
          if (btn && btn.disabled) return;
          event.preventDefault();
          if (form.requestSubmit) { form.requestSubmit(btn || undefined); } else { form.submit(); }
        });
      }, bar);
    }, root);
  }

  function start() {
    init(document);
    setInterval(function () {
      ticks = ticks.filter(function (tick) { return tick(); });
    }, 1000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }

  /* Re-run when a section is added or re-rendered in the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
